import { Elements, CardElement, ElementsConsumer } from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import { connect } from "react-redux"
import React, { Component } from "react"
import { createAction } from "redux-actions"
import { Helmet } from "react-helmet";
import FaLock from 'react-icons/lib/fa/lock'
import { browserHistory, Link } from "react-router"
import ReCAPTCHA from "react-google-recaptcha";
import "./settings.css"

import {
  UPDATE_CARD,
  userChangePayment,
  fetchExtraUserInfo,
  log
} from "../../actions"


const mapStateToProps = (state, ownProps) => {
  const { me, checkout } = state
  return {
    checkout,
    me
  }
}

class ChangePayment extends Component {
  stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY)
  recaptchaRef = React.createRef();

  constructor() {
    super()
  }

  componentDidMount() {
    if (!this.props.me.user_name) {
      browserHistory.push('/login?redirect=%2Fchange_payment')
    }
  }

  render() {
    const { dispatch, checkout, viewParams, me } = this.props

    // reset it on error so the user can try again
    if (checkout.error) {
      window.grecaptcha.reset()
    }

    return (
      <Elements stripe={this.stripePromise}>
        <ElementsConsumer>
          {({elements, stripe}) => (
            <div className="settings">
              <Helmet>
                <title>Change Payment - Streamable</title>
                <meta name="description" content="Update your card."></meta>
                <link rel="canonical" href={`https://streamable.com/change_payment`} />
              </Helmet>
              <div className="card change-payment">
                <div className="card-header">
                  Update Card
                </div>
                <div className="card-block">
                  <form
                    style={{marginBottom:'5px'}}
                    onSubmit={async (e) => {
                      e.preventDefault();

                      dispatch(log("CHANGE PAYMENT RECAPTCHA SHOWN"))
                      const start = Date.now()
                      const token = await this.recaptchaRef.current.executeAsync();
                      const delta = Date.now() - start
                      dispatch(log("CHANGE PAYMENT RECAPTCHA TOKEN RETURNED IN " + delta.toString()  + "ms"))

                      // this is necessary so it can be run again on error!
                      this.recaptchaRef.current.reset()
                      if (!stripe || !elements || !token) {
                        return;
                      }
                      dispatch(createAction(UPDATE_CARD)({purchasing: true}))

                      const cardElement = elements.getElement(CardElement);
                  
                      const {error, paymentMethod} = await stripe.createPaymentMethod({
                        type: 'card',
                        card: cardElement,
                      });

                      this.setState({ error })
                  
                      if (error) {
                        dispatch(createAction(UPDATE_CARD)(new Error(error.message)))
                        return
                      }
                      
                      stripe.createPaymentMethod({
                        type: 'card',
                        card: cardElement,
                      }).then(async (result, email) => {
                        
                        if (result.error) {
                          dispatch(createAction(UPDATE_CARD)(new Error(result.error)))
                        } else {
                          const user = await dispatch(userChangePayment(result.paymentMethod.id, token))
                          if (user && !user.error) {
                            await dispatch(fetchExtraUserInfo('billing_info'))
                            browserHistory.push(`/billing?alert=card_changed`)
                          }
                        }
                      })
                    }}
                  >
                    <CardElement
                      onReady={() => {
                        this.props.dispatch(createAction(UPDATE_CARD)({ purchasing: false, error: false, message: null }))
                      }}
                      options={{
                        hidePostalCode: false,
                        style: {
                          base: {
                            fontSize: '16px',
                            color: 'rgb(116, 132, 144)',
                            fontFamily: 'Open Sans, sans-serif',
                            fontSize: '1rem',
                            border: '1px solid #ced4da',
                            '::placeholder': {
                              color: '#aaa',
                            },
                          },
                          invalid: {
                            color: '#9e2146',
                          },
                        },
                      }}
                    />
                    {checkout.error ? <div className="alert alert-warning">{checkout.message}</div> : ''}
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      <span style={{marginTop: '1px'}}><FaLock /></span><span style={{flex: 1, marginLeft: '5px'}}>Secured with SSL encryption</span>
                      <button
                        id="submit"
                        type="submit"
                        className={`blue-button ${checkout.purchasing || !stripe ? 'disabled': ''}`}
                        disabled={checkout.purchasing || !stripe}
                      >
                        Update Card
                      </button>
                    </div>
                    <ReCAPTCHA
                      ref={this.recaptchaRef}
                      size="invisible"
                      sitekey="6LefNMAZAAAAANHI6PRR6Vh9yMBsCmipPTw8jPOP"
                    />   
                  </form>
                </div>
              </div>
            </div>
          )}
        </ElementsConsumer>
      </Elements>
    )
  }
}

export default connect(mapStateToProps)(ChangePayment)
